import { createFileRoute, useRouter } from "@tanstack/react-router";
import type { JSX } from "react";

import { UserQueryDocument } from "@repo/graphql-types/graphql";

import { CreditCardForm } from "@/components/payment/forms/credit-card-form.tsx";
import { FlowHeader } from "@/components/ui/flow-header/flow-header.tsx";
import { Page, PageTitle } from "@/components/ui/layout/page/page.tsx";
import { RoundedLayout } from "@/components/ui/layout/rounded-layout.tsx";
import { useInvalidateQuery } from "@/hooks/use-graphql.ts";

const AddPaymentCardCreatePage = (): JSX.Element => {
  const router = useRouter();

  const invalidateUserQuery = useInvalidateQuery(UserQueryDocument);

  const onSuccess = async (): Promise<void> => {
    invalidateUserQuery();

    await router.navigate({
      to: "/add-payment-card/success",
      replace: true,
    });
  };

  return (
    <RoundedLayout>
      <FlowHeader>
        <FlowHeader.Actions>
          <FlowHeader.BackButton />
          <FlowHeader.HelpButton />
        </FlowHeader.Actions>
        <FlowHeader.ProgressBar progress={9 / 10} />
      </FlowHeader>

      <Page className="flex flex-col gap-6 px-6 pt-0" showCustomerIoContainer={false}>
        <PageTitle>Cadastre o seu cartão</PageTitle>
        <div className="w-full">
          <CreditCardForm
            onSuccess={() => {
              void onSuccess();
            }}
          />
        </div>
      </Page>
    </RoundedLayout>
  );
};

export const Route = createFileRoute("/add-payment-card/create")({
  component: AddPaymentCardCreatePage,
});
